import { useQuery } from '@tanstack/react-query';
import { IntakeDetectionResponse } from '@shared';
import { intakeDetectionApi, intakeDetectionKeys } from '@client/api/waterlily';

export function useIntakeDetection(clientId: string) {
  return useQuery<IntakeDetectionResponse>({
    queryKey: intakeDetectionKeys.detail(clientId),
    queryFn: () => intakeDetectionApi.getIntakeDetection(clientId),
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
